<app-header></app-header>
<app-menu></app-menu>
<div nxLayout="grid" class="nx-margin-top-2m">
  <div nxRow nxRowAlignItems="start,start,center,center">
    <div nxCol="12,6,4,2" nxColOffset="1">
      <nx-formfield nxLabel="Select Dealer">
        <nx-dropdown #selectedClient (selectionChange)="onDealerChanges($event)">
          <nx-dropdown-item *ngFor="let item of workshopList" [nxValue]="item.workshopId">
            {{ item.workshopName }}
          </nx-dropdown-item>
        </nx-dropdown>
      </nx-formfield>
    </div>
    <div nxCol="12,6,8,10"></div>
  </div>
  <div nxRow nxRowAlignItems="start,start,center,center" *ngIf="isDealer">
    <div nxCol="12,12,6,2" nxColOffset="1">
      <nx-formfield nxLabel="Start date">
        <input nxDatefield nxInput [nxDatepicker]="startDatepicker" [(ngModel)]="policyStartDate" />
        <nx-datepicker-toggle [for]="startDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
        <nx-datepicker #startDatepicker></nx-datepicker>
        <nx-error nxFormfieldError>
          <strong>Please note:</strong> this field is required!
        </nx-error>
        <span nxFormfieldHint> MM/DD/YYYY </span>
      </nx-formfield>
    </div>
    <div nxCol="12,12,6,2" nxAlignSelf="center">
      <nx-formfield nxLabel="End date">
        <input nxDatefield nxInput [nxDatepicker]="endDatepicker" [(ngModel)]="policyEndDate" />
        <nx-datepicker-toggle [for]="endDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
        <nx-datepicker #endDatepicker></nx-datepicker>
        <nx-error nxFormfieldError>
          <strong>Please note:</strong> this field is required!
        </nx-error>
        <span nxFormfieldHint> MM/DD/YYYY </span>
      </nx-formfield>
    </div>
    <div nxCol="12,12,6,2">
      <nx-formfield>
        <input nxInput placeholder="Enter Keyword" [(ngModel)]="searchTerm" type="search" />
        <span nxFormfieldPrefix>
          <nx-icon name="search" size="s"></nx-icon>
        </span>
        <span nxFormfieldSuffix *ngIf="searchTerm" aria-hidden="true" (click)="searchTerm = ''; getinvoiceList()">
          <nx-icon name="close" size="s"></nx-icon>
        </span>
      </nx-formfield>
    </div>
    <div nxCol="12,12,6,1" class="nx-margin-top-2xs">
      <button nxButton="primary small-medium" type="button" (click)="getinvoiceList()">
        Search
      </button>
    </div>
    <div nxCol="12,6,4,3" class="nx-margin-top-2xs" style="float: right">
          <button (click)="toggleModal(false, 0)" nxButton="secondary " type="button">
            Add Invoice
          </button>
          <button nxButton="secondary" type="button" (click)="exporttoexcel()" class="nx-margin-left-3m" >
            <nx-icon name="xls" class="nx-margin-right-2xs" style="color: green;"></nx-icon>Export
          </button>
    </div>
  </div>

  <div nxRow *ngIf="invoiceList.length != 0">
    <div nxCol="10" nxColOffset="1">
      <table nxTable condensed nxSort (sortChange)="sortTable($event)">
        <thead>
          <tr nxTableRow>
            <th nxHeaderCell nxSortHeaderCell="invoiceNumber">Invoice Number</th>
            <th nxHeaderCell nxSortHeaderCell="invoiceDate">Invoice Date</th>
            <th nxHeaderCell nxSortHeaderCell="serviceDate">Service Date</th>
            <th nxHeaderCell nxSortHeaderCell="invoiceAmount">Invoice Amount</th>
            <th nxHeaderCell nxSortHeaderCell="typeofService">TypeofService</th>
            <th nxHeaderCell>Edit</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          <tr nxTableRow *ngFor="let item of invoiceList">
            <td nxTableCell>{{ item.invoiceNumber }}</td>
            <td nxTableCell>{{ item.invoiceDate | date: "MM/dd/yyyy"  }}</td>
            <td nxTableCell>{{ item.serviceDate | date: "MM/dd/yyyy"  }}</td>
            <td nxTableCell>{{ item.invoiceAmount }}</td>
            <td nxTableCell>{{ item.typeofService }}</td>
            <td nxTableCell>
              <button nxIconButton="tertiary  small" (click)="toggleModal(true, item.id)" class="nx-margin-top-m">
                <nx-icon name="edit" size="s"> </nx-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div nxRow class="nx-margin-top-2m nx-margin-right-5xl" style="float: right">
    <div nxCol="6">
      <nx-pagination [nxCount]="count" [nxPage]="pageNumber" [nxPerPage]="pageSize" nxType="advanced"
        (nxGoPrev)="prevPage()" (nxGoNext)="nextPage()" (nxGoPage)="goToPage($event)">
      </nx-pagination>
    </div>
  </div>
  <div nxRow>
  <div nxCol="12,10" class="nx-margin-top-2xl" *ngIf="invoiceList.length == 0">
    <ng-container>
      <div nxRow nxRowJustify="center">
        <div nxCol="12" class="nosearchresult"></div>
        <h3 nxHeadline="subsection-medium" class="nx-font-weight-semibold">
          No Records found !!!
        </h3>
      </div>
    </ng-container>
  </div>
  </div>
</div>
<app-footer></app-footer>
<!--Modal for create Invoice-->
<nx-modal #addInvoiceModal [nxHideOnClickOutside]="false" [nxHideOnEsc]="false" *ngIf="invoiceModalOpen"
  [nxShowCloseIcon]="false">
  <div *ngIf="!isSuccess">
    <form [formGroup]="invoiceForm">
      <div nxLayout="grid">
        <div nxRow nxRowJustify="start,around">
          <h2 nxHeadline="section" *ngIf="!EDIT_FLAG">Add Invoice</h2>
          <h2 nxHeadline="section" *ngIf="EDIT_FLAG">Edit Invoice</h2>
        </div>

        <div nxRow>
          <div nxCol="12" nxAlignSelf="center" [ngClass]="{ disabledbutton: EDIT_FLAG }">
          </div>
        </div>

        <div nxRow>
          <div nxCol="12,6" nxAlignSelf="center">
            <nx-formfield nxLabel="Invoice Number">
              <input nxInput formControlName="invoiceNumber" />
              <nx-error nxFormfieldError>
                <div
                *ngIf="invoiceFormControls.invoiceNumber.errors?.required"
              >
              <strong>Please note:</strong> this field is required!
              </div>
                <div
                *ngIf="invoiceFormControls.invoiceNumber.errors?.pattern"
              >
                <strong>Please note:</strong> Enter Valid details
                <br />Allowed charcters are -_,/.&lt;space&gt; and Alpha
                numerics.
              </div>
              </nx-error>
            </nx-formfield>
          </div>
          <div nxCol="12,6" nxAlignSelf="center">
            <nx-formfield nxLabel="Invoice Amount">
              <input nxInput formControlName="invoiceAmount" [readonly]="EDIT_FLAG" />
              <nx-error nxFormfieldError>
                <div
                *ngIf="invoiceFormControls.invoiceAmount.errors?.required"
              >
              <strong>Please note:</strong> this field is required!
              </div>
                <div
                *ngIf="invoiceFormControls.invoiceAmount.errors?.pattern"
              >
                <strong>Please note:</strong> Enter only digits.
              </div>
              </nx-error>
            </nx-formfield>
          </div>
        </div>
        <div nxRow>
        </div>
        <div nxRow>
          <div nxCol="12,6" nxAlignSelf="center">
            <nx-formfield nxLabel="Invoice date">
              <input formControlName="invoiceDate" nxDatefield nxInput [nxDatepicker]="invoiceDatepicker" />
              <nx-datepicker-toggle [for]="invoiceDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #invoiceDatepicker></nx-datepicker>
              <nx-error nxFormfieldError>
                <strong>Please note:</strong> this field is required!
              </nx-error>
               <span nxFormfieldHint> MM/DD/YYYY </span>
            </nx-formfield>
          </div>
          <div nxCol="12,6" nxAlignSelf="center">
            <nx-formfield nxLabel="Service date">
              <input formControlName="serviceDate" nxDatefield nxInput [nxDatepicker]="serviceDatepicker" />
              <nx-datepicker-toggle [for]="serviceDatepicker" nxFormfieldSuffix></nx-datepicker-toggle>
              <nx-datepicker #serviceDatepicker></nx-datepicker>
              <nx-error nxFormfieldError>
                <strong>Please note:</strong> this field is required!
              </nx-error>
               <span nxFormfieldHint> MM/DD/YYYY </span>
            </nx-formfield>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12,6" nxAlignSelf="center">
            <nx-formfield nxLabel="Type of Service">
              <input nxInput formControlName="typeofService" />
              <nx-error nxFormfieldError>
                <div
                *ngIf="invoiceFormControls.typeofService.errors?.required"
              >
              <strong>Please note:</strong> this field is required!
              </div>
                <div
                *ngIf="invoiceFormControls.typeofService.errors?.pattern"
              >
                <strong>Please note:</strong> Alphanumeric characters only allowed.
              </div>
              </nx-error>
            </nx-formfield>
          </div>
        </div>
        <div nxRow>
          <div nxCol="12" style="text-align: center">
            <button *ngIf="!EDIT_FLAG" (click)="addInvoice()" [disabled]="invoiceForm.invalid" nxButton="primary"
              type="button">
              Add
            </button>
            <button *ngIf="EDIT_FLAG" (click)="updateInvoice()" [disabled]="invoiceForm.invalid" nxButton="primary"
              type="button">
              Update
            </button>
            <button (click)="toggleModal(false, 0)" nxButton="secondary" type="button" class="nx-margin-left-2m">
              Close
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="isSuccess">
    <div nxRow nxRowJustify="start,around">
    </div>
    <div nxRow nxRowJustify="center" class="nx-margin-top-m nx-margin-bottom-s">
      <div nxCol="12">
        <h3 class="u-text-align-center" nxHeadline="subsection-xsmall" *ngIf="!EDIT_FLAG">
          Invoice added successfully
        </h3>
        <h3 class="u-text-align-center" nxHeadline="subsection-xsmall" *ngIf="EDIT_FLAG">
          Invoice updated successfully
        </h3>
      </div>
    </div>
    <div class="nx-margin-top-2m" nxRow nxRowJustify="center">
      <div nxCol="12">
        <button (click)="toggleModal(false, 0)" nxButton="block primary">
          close
        </button>
      </div>
    </div>
  </div>
</nx-modal>